<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter26">
<h1><a id="page_44"></a><a href="#/003toc#ch26">Mom’s Chicken Noodle Goodness</a></h1>
<p class="noindent">Mom’s comfort food, this noodle soup is filled with veggies and chunks of chicken to make even the worst day seem bearable. Pair this with Cheddar cheese biscuits or scones.</p>
<p class="noindent">2 tablespoons olive oil</p>
<p class="noindent">1 cup finely chopped onion</p>
<p class="noindent">2 cups finely chopped celery</p>
<p class="noindent">2 cups finely chopped carrot</p>
<p class="noindent">2 small zucchini, finely chopped</p>
<p class="noindent">1 teaspoon dried thyme</p>
<p class="noindent">12 cups chicken broth</p>
<p class="noindent">4 cups bite-size pieces cooked chicken</p>
<p class="noindent">Two 10-ounce packages fresh baby spinach</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">8 ounces medium-width egg noodles, cooked al dente</p>
<p class="noindent">heat the oil in a large skillet over medium-high heat. Add the onion, celery, carrot, zucchini, and thyme and sauté until the vegetables are softened, about 7 minutes.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Stir in the broth, chicken, and spinach.</p>
<p class="noindent">cover and cook on high for 4 hours or on low for 8 hours.</p>
<p class="noindent">season with salt and pepper. Add the noodles to the soup, stir, cover, and let stand for 5 minutes before serving.</p>
<p class="noindent">serves 8–10</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 032-chapter26.vue?32d4bb3e